module.exports = __webpack_public_path__ + "static/img/6.83dfa57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/6.jpg
// module id = 47
// module chunks = 1 4